export default {
  time_options: {
    asap: {
      title: 'Mahdollisimman pian',
      description: 'Valmis {{time}} min kuluttua',
    },
    scheduled: {
      title: 'Aikatauluta myöhemmäksi',
    },
  },
};
